module.exports = __webpack_public_path__ + "static/media/3_graph1.e4853b18.svg";